import { render, staticRenderFns } from "./ConfiguracaoForm.vue?vue&type=template&id=4541760e&scoped=true&"
import script from "./ConfiguracaoForm.vue?vue&type=script&lang=js&"
export * from "./ConfiguracaoForm.vue?vue&type=script&lang=js&"
import style0 from "./ConfiguracaoForm.vue?vue&type=style&index=0&id=4541760e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4541760e",
  null
  
)

export default component.exports